'use client';

import { createContext, useContext, type ReactNode } from 'react';

/**
 * Where the federated miniapp is deployed, resolved on the server.
 *
 * The root layout asks the registry while it renders and hands the answer down,
 * so it is already in the payload by the time anything mounts — no client round
 * trip stands between the page and the miniapp starting to load.
 *
 * `null` when the registry could not be reached. The consumers treat that as
 * "no miniapp this render" rather than guessing a URL, which is the honest
 * outcome: a wrong base would fail later and less clearly.
 */
const DeploymentContext = createContext<string | null>(null);

export const MiniappDeploymentProvider = ({ deploymentUrl, children }: { deploymentUrl: string | null; children: ReactNode }) => (
  <DeploymentContext.Provider value={deploymentUrl}>{children}</DeploymentContext.Provider>
);

/** The deployment base to load the miniapp from, as resolved on the server. */
export const useMiniappDeploymentUrl = (): string | null => useContext(DeploymentContext);

export default MiniappDeploymentProvider;
